import React, { useEffect, useState } from "react";
import "./ManageHotelBooking.scss";
import { useAdmin } from "../../../contexts/AdminContext";
import {
  handleDeleteHotelApiCall,
  handleGetAllHotelApiCall,
} from "../../../utils/AdminApiCall";
import CustomButton from "../../../components/CustomButton";
import AddHotelFormPopUp from "../../../containers/AddHotelFormPopUp";
import ConformPopUp from "../../../containers/ConformPopUp";
import { fas } from "@fortawesome/free-solid-svg-icons";

const ManageHotelBooking = () => {
  const adminContext = useAdmin();

  const [confirmPopUp, setConfirmPopUp] = useState({
    visible: false,
    deleteId: null,
  });
  const handleAddHotelBtn = () => {
    adminContext.handleSetHotelFormPopUp((prevState) => {
      return {
        ...prevState,
        visible: true,
      };
    });
  };
  const handleViewBtnClick = () => {};
  const handleEditBtn = (hotel) => {
    adminContext.handleSetHotelFormPopUp((prevState) => {
      return {
        ...prevState,
        visible: true,
        data: hotel,
      };
    });
  };
  const handleDeleteBtn = (hotelId) => {
    const response = handleDeleteHotelApiCall(hotelId);
    response.then((res) => {
      if (res?.status === 200) {
        alert(res?.data);
        handleInitialApiCall();
      } else {
        alert("Error while deleting hotel");
      }
    });
  };

  useEffect(() => {
    handleInitialApiCall();
  }, []);
  const handleInitialApiCall = () => {
    const response = handleGetAllHotelApiCall();
    response.then((res) => {
      if (res.status === 200) {
        adminContext.handleSetHotelList(res.data);
      }
    });
  };

  const handleDeleteBtnClick = (hotelId) => {
    setConfirmPopUp((prevState) => {
      return {
        ...prevState,
        visible: true,
        deleteId: hotelId,
      };
    });
  };

  const onConfirm = () => {
    const tempObj = { ...confirmPopUp };
    handleDeleteBtn(tempObj.deleteId);
    setConfirmPopUp({
      ...confirmPopUp,
      visible: false,
      deleteId: null,
    });
  };

  const onCancel = () => {
    setConfirmPopUp({
      ...confirmPopUp,
      visible: false,
      deleteId: null,
    });
  };
  return (
    <>
      <div className="ManageHotelBooking">
        <div className="Manage">
          <div className="manage-header">
            <h2>Manage Hotel</h2>
            <button className="add-btn" onClick={handleAddHotelBtn}>
              Add Hotel
            </button>
          </div>
          <table className="manage-table">
            <thead>
              <th>Hotel No</th>
              <th>Hotel Name</th>
              <th>City</th>
              <th>State</th>
              <th>Country</th>
              <th>Description</th>
              {/* <th>Manage Rooms</th> */}
              <th>Action</th>
            </thead>
            <tbody>
              {adminContext?.hotelList &&
                adminContext?.hotelList.map((hotel, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{hotel.hotelName}</td>
                      <td>{hotel.city}</td>
                      <td>{hotel.state}</td>
                      <td>{hotel.country}</td>
                      <td>{hotel.description}</td>
                      {/* <td>
                        <button
                          className="view-btn"
                          onClick={handleViewBtnClick}
                        >
                          view
                        </button>
                      </td> */}
                      <td>
                        <button
                          className="edit-btn"
                          onClick={() => handleEditBtn(hotel)}
                        >
                          Edit
                        </button>{" "}
                        <button
                          className="delete-btn"
                          onClick={() => handleDeleteBtnClick(hotel.hotelId)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
      {adminContext?.hotelFormPopUp?.visible && <AddHotelFormPopUp />}
      {confirmPopUp.visible && (
        <ConformPopUp
          description="Are you sure to delete!"
          onConfirm={onConfirm}
          onCancel={onCancel}
        />
      )}
    </>
  );
};

export default ManageHotelBooking;
